import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import UserManagementStore from '../stores/UserManagementStore';
import { parseCustomerDetailsReponse } from '../parsers/CustomerDetailsParser';

const getCustomerDetailsEndpoint =
  '/ibapi/v2/banks/{bank-id}/customers/{customerId}';

const putPersonalContactPreferenceEndpoint =
  '/ibapi/v2/banks/{bank-id}/customers/personal/{customerId}';

export const requestCustomerDetails = async () => {
  const user = UserManagementStore.getCADetails();
  const customerId = user?.customers?.[0].customer_id;
  const url =
    `${envConfig.apiBaseUrlPAAS}${getCustomerDetailsEndpoint}`.replace(
      '{customerId}',
      customerId
    );

  return new Promise((resolve, reject) => {
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.customerServices,
        method: 'GET',
        url,
        addAuthToken: true,
        doNotTrackCallProgress: true,
      },
      (data) => {
        if (!data) {
          return reject();
        }

        return resolve(parseCustomerDetailsReponse(data));
      },
      () => reject()
    );
  });
};

export const updateContactPreference = async (contactPreference) => {
  const user = UserManagementStore.getCADetails();
  const customerId = user?.customers?.[0].customer_id;
  const url =
    `${envConfig.apiBaseUrlPAAS}${putPersonalContactPreferenceEndpoint}`.replace(
      '{customerId}',
      customerId
    );

  return new Promise((resolve, reject) => {
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.customerServices,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData: {
          applicants: [
            {
              id: customerId,
              contact_details: {
                preferred_contact: contactPreference,
              },
            },
          ],
        },
        doNotTrackCallProgress: true,
      },
      () => resolve(),
      () => reject()
    );
  });
};
